/**
 * @description Hook utilizado para manipular as requisicoes
 * @author Núcleo de Tecnologia da Informação - NTI
 * @file useRequisicaoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useRequisicaoService = () => {
  const fetch = useFetch()

  const listarRequisicoes = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`requisicao/listarRequisicoes/`)
      return response.data.requisicoes
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRequisicoesPorSetores = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)

      const response = await fetch.get(`requisicao/requisicoesPorSetores/`)

      return response.data.requisicoes
    } catch (err) {
      console.error('Erro ao listar requisições por setores:', err)
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRequisicaoPorIdAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/requisicao/${id}`)
      return response.data.requisicao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRequisicoesFiltradosAsync = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const filtros = {
        idsCaso: dados.caso ? dados.caso : null,
        idsAutoridadeRequisitante: dados.autoridadeRequisitante ? dados.autoridadeRequisitante.map((usuario) => usuario.id) : null,
        idsOrgaoOrigem: dados.orgaoOrigem ? dados.orgaoOrigem.map((orgao) => orgao.id) : null,
        idsSetorSolicitante: dados.setorSolicitante ? dados.setorSolicitante.map((setor) => setor.id) : null,
        idsSetorDestino: dados.setorDestino && dados.setorDestino ? dados.setorDestino.map((setor) => setor.id) : null,
        dataCadastroInicio: dados.dataCadastroChecked && dados.dataCadastroInicio ? dados.dataCadastroInicio : null,
        dataCadastroFinal: dados.dataCadastroChecked && dados.dataCadastroFinal ? dados.dataCadastroFinal : null,
        tipo: dados.tipo ? dados.tipo : null,
        nic: dados.nic ? dados.nic : null,
        identificadorCasoRip: dados.identificadorCasoRip ? dados.identificadorCasoRip : null,
        resumoOcorrencia: dados.resumoOcorrencia ? dados.resumoOcorrencia : null,
        statusRequisicao: dados.statusRequisicao ? dados.statusRequisicao : null,
        observacoes: dados.observacoes ? dados.observacoes : null,
      }
      const response = await fetch.postOpenWithoutFeedback('requisicao/filtrar/', filtros)
      return response.data.requisicoes
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRequisicaoLikeStringAsync = async (string, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`requisicao/filtrar/porstring/${string}`)
      return response.data.requisicoes
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const importarRequisicaoNoCaso = async (idCaso, requisicaoImportar, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.postOpenWithoutFeedback(`/requisicao/importarRequisicaoNoCaso/${idCaso}`, requisicaoImportar)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRequisicaoDeCasoAsync = async (idCaso, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/requisicao/listarRequisicaoDeCaso/${idCaso}`)
      return response.data.requisicoes
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const despacharRequisicoes = async (despacho, idRequisicao, setProcessandoDespachar) => {
    const dados = { despacho, id: idRequisicao }

    try {
      if (setProcessandoDespachar) setProcessandoDespachar(true)

      const response = await fetch.postOpenWithoutFeedback('requisicao/despacharRequisicao/', dados)

      return response.data?.response.success
    } catch (err) {
      console.error('Erro ao despachar requisições:', err)
      return null
    } finally {
      if (setProcessandoDespachar) setProcessandoDespachar(false)
    }
  }

  return {
    listarRequisicaoPorIdAsync,
    listarRequisicoesFiltradosAsync,
    listarRequisicaoLikeStringAsync,
    listarRequisicoes,
    importarRequisicaoNoCaso,
    listarRequisicaoDeCasoAsync,
    listarRequisicoesPorSetores,
    despacharRequisicoes,
  }
}
